import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { api } from 'src/Basic/ApiFetch';
import { showGlobalMessageBox, getGlobalServerConfig } from 'src/Route/RootMiddleware';
import TextInputForm from 'src/Components/Input/TextInputForm';
import { Button } from '@progress/kendo-react-buttons';
import { Captcha } from "src/Components/Captcha/Captcha";
import { getCaptchaService } from "src/HomePage/CaptCha.service";
import EmailSent from 'src/HomePage/ForgotPw/EmailSent'; // 引入寄信後的畫面
import { isWebSiteClose } from 'src/Basic/CommonService';

const ForgotPW = ({ returnLogin }) => {

    const [data, setData] = useState({
        USER_EMAIL: "",
        Captcha: "",
        CaptchaEncoded: ""
    });
    const initCaptchaEncode = { CaptchaEncode: "" }; //驗證碼初始化
    const [captchaTxt, setCaptcha] = useState(initCaptchaEncode);
    const [isSubmitted, setIsSubmitted] = useState(false); // 控制 component 顯示狀態
    const [submittedEmail, setSubmittedEmail] = useState(""); // 新增這個狀態來保存提交的USER_EMAIL

    //頁面初始化
    useEffect(() => {
        initPage();
    }, []);

    /**
     * 初始化頁面：先判斷網站是否關閉，才顯示表單
     * 忘記密碼頁面初始化時 email 尚未輸入，不需要特權帳號判斷。
     */
    const initPage = async () => {
        if (await isWebSiteClose()) {
            showGlobalMessageBox("系統維護中，暫不開放", () => { returnLogin() });
        }
        else {
            await getCaptcha();
        }
    }
    /**
     * 
     * @param {*} data 使用者填入的資料(信箱、驗證碼)
     */
    // 寄發密碼信
    const submit = async (data) => {
        let forgotPWData = { ...data, CaptchaEncoded: captchaTxt.CaptchaEncode };
        let url = getGlobalServerConfig().backEndUrl.get() + 'Login/ForgotPW';
        let response = await api.Post(url, JSON.stringify(forgotPWData));
        let result = await response.json();
        if (result.success) {
            setSubmittedEmail(data.USER_EMAIL); // 保存提交的USER_EMAIL
            setIsSubmitted(true) //顯示已繳交的畫面
        }
        else {
            showGlobalMessageBox(result.message);
        }
    }

    //獲取驗證碼
    const getCaptcha = async (e) => {
        if (e) e.preventDefault();
        const captchaData = await getCaptchaService();
        if (captchaData) {
            setCaptcha(captchaData);
        }
    };


    //欄位驗證
    const validateField = Yup.object().shape({
        USER_EMAIL: Yup.string()
            .email("請輸入正確的email格式")
            .max(100, "長度不得超過100個字")
            .required('請輸入會員帳號'),
        Captcha: Yup.string().required("請輸入驗證碼")
    });

    //拉出去
    //寄信後的畫面
    if (isSubmitted) {
        return (
            <EmailSent
                submittedEmail={submittedEmail}
                returnLogin={returnLogin}
                setIsSubmitted={setIsSubmitted}
            />
        );
    }

    return (
        <div className="login_content_right_box_width">
            <div className="login_box">
                <Formik
                    initialValues={data}
                    validationSchema={validateField}
                    onSubmit={(data) => submit(data)}
                >
                    {prop => {
                        const {
                            values,
                            errors,
                            handleBlur,
                            handleSubmit,
                            handleChange,
                        } = prop;
                        return (
                            <form onSubmit={handleSubmit} >
                                <div className="form_top_header_return" onClick={() => returnLogin()}>返回登入頁</div>
                                <div className="login_box_header p-t20">
                                    <div className="login_box_headline me-auto">忘記密碼</div>
                                </div>
                                <div className="login_box_input">
                                    <div className="login_box_txt">會員帳號</div>
                                    <TextInputForm
                                        onChange={handleChange}
                                        value={values.USER_EMAIL}
                                        name="USER_EMAIL"
                                        onBlur={handleBlur}
                                        error={errors.USER_EMAIL}
                                        placeholder="請輸入會員帳號"
                                        readOnly={false}
                                        autoUppercase={false}
                                    />
                                    <div className="login_box_txt">驗證碼</div>
                                    <div className="flex">
                                        <div className="me-lg-auto-width">
                                            <TextInputForm
                                                onChange={handleChange}
                                                value={values.Captcha}
                                                name="Captcha"
                                                onBlur={handleBlur}
                                                error={errors.Captcha}
                                                placeholder="請輸入驗證碼"
                                                readOnly={false}
                                                autoUppercase={false}
                                            />
                                        </div>
                                        <div className="flex_center">
                                            <div className="margin_xl10">
                                                {captchaTxt.Img && (
                                                    <Captcha
                                                        Img={captchaTxt.Img}
                                                        GetCaptcha={getCaptcha}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="margin_t30"></div>

                                    <Button type="button"
                                        onClick={handleSubmit}
                                        style={{
                                            padding: "16px 36px 16px 36px",
                                            gap: "10px",
                                            background: "#00A698",
                                            fontSize: "18px",
                                            fontWeight: 500,
                                            lineHeight: "26px",
                                            textAlign: "center",
                                            color: "#FFFFFF",
                                            width: "100%"
                                        }} >寄送驗證信</Button>
                                </div>
                            </form>
                        );
                    }}
                </Formik>
            </div>
        </div>
    )
}

export default ForgotPW;